import type { JSX } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { ClientRender } from '@change-corgi/core/react/ssr/render';

import { SetPageStateValue } from 'src/shared/pageState';

import {
	StarterDashboardV2BreakpointStateProvider,
	useStarterDashboardV2PageNotificationManagerContext,
} from 'src/app/pages/starterDashboardV2/pageContext';
import { AppDownloadBottomBanner } from 'src/app/shared/components/appDownloadBottomBanner';

import { PageBody } from '../components/PageBody';
import { PageHeader } from '../components/PageHeader';

import { usePageStateValue } from './hooks/usePageStateValue';
import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	const { section } = useKnownAvailableParams();

	useTrackPageView(section);
	const { petition, ownPetition, mobileAppDownloadBannerEnabled } = usePageStateValue();
	const {
		data: { notification },
	} = useStarterDashboardV2PageNotificationManagerContext();

	// We depend on client breakpoints
	return (
		<>
			<SetPageStateValue name="petition" value={petition} />
			<ClientRender placeholder={<div className="h-16" />}>
				<StarterDashboardV2BreakpointStateProvider>
					<PageHeader />
					<div className="h-full w-full bg-fill-inverse-strong">
						{notification?.content}
						<PageBody />
					</div>
				</StarterDashboardV2BreakpointStateProvider>
			</ClientRender>
			<AppDownloadBottomBanner
				sourceLocation="petition_dashboard"
				ownPetition={ownPetition}
				enabled={mobileAppDownloadBannerEnabled}
			/>
		</>
	);
}
